import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const SeeIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M12.0326 17.5807C9.11942 17.5807 6.74512 15.212 6.74512 12.2933C6.74512 9.37453 9.1138 7.00584 12.0326 7.00584C14.9513 7.00584 17.32 9.37453 17.32 12.2933C17.32 15.212 14.9513 17.5807 12.0326 17.5807ZM12.0326 8.12844C9.73685 8.12844 7.86772 9.99757 7.86772 12.2933C7.86772 14.589 9.73685 16.4581 12.0326 16.4581C14.3283 16.4581 16.1974 14.589 16.1974 12.2933C16.1974 9.99757 14.3283 8.12844 12.0326 8.12844Z"
                fill="currentColor"
            />
            <path
                d="M11.9154 19.3825C5.63447 19.3825 0.897098 12.7087 0.700643 12.4224C0.627674 12.3214 0.599609 12.2035 0.599609 12.0912C0.599609 11.9734 0.633287 11.8555 0.706256 11.7544C0.908324 11.4682 5.74673 4.79994 12.0838 4.79994C19.0888 4.79994 23.1526 11.5075 23.321 11.7937C23.3715 11.8779 23.3996 11.979 23.3996 12.08C23.3996 12.181 23.3715 12.3101 23.3154 12.3999C23.1358 12.6862 18.8643 19.3825 11.9154 19.3825ZM1.85692 12.0968C2.86165 13.3934 6.95352 18.2599 11.9154 18.2599C17.4723 18.2599 21.3003 13.3261 22.176 12.0856C21.3396 10.8395 17.6687 5.92254 12.0838 5.92254C7.05456 5.92254 2.87849 10.8002 1.85692 12.0968Z"
                fill="currentColor"
            />
        </Icon>
    )
}

SeeIcon.propTypes = {
    secondaryColor: PropTypes.string,
}

export default SeeIcon
